module.exports = __webpack_public_path__ + "./images/DatosGenerales.9e6e4f7923308225800a0f31ca9aadc3.png";


//////////////////
// WEBPACK FOOTER
// ./websources/public/images/DatosGenerales.png
// module id = ./websources/public/images/DatosGenerales.png
// module chunks = 0